import { DrpxLogo, DrpxLogoIcon } from '../logo/DrpxLogo';
import type { TranslateFn } from '../../types';

interface LoadingScreenProps {
  darkMode: boolean;
  t: TranslateFn;
}

/** LoadingScreen — Splash-Screen beim App-Start. */
export function LoadingScreen({ darkMode, t }: LoadingScreenProps) {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: darkMode ? '#000000' : '#f5f5f7',
        fontFamily: "'DM Sans',sans-serif",
        position: 'relative' as const,
        overflow: 'hidden',
      }}>
      <div className="grain-overlay" />
      <div
        style={{ textAlign: 'center' as const, animation: 'fadeInScale .6s cubic-bezier(.2,0,.1,1)' }}>
        <div
          style={{ position: 'relative' as const, width: 72, height: 72, margin: '0 auto 20px' }}>
          <div
            style={{
              position: 'absolute' as const,
              inset: 0,
              border: '3px solid rgba(74,222,128,.1)',
              borderTopColor: '#4ade80',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
            }} />
          <div
            style={{
              position: 'absolute' as const,
              inset: 6,
              border: '2px solid rgba(74,222,128,.05)',
              borderBottomColor: 'rgba(74,222,128,.4)',
              borderRadius: '50%',
              animation: 'spin 1.5s linear infinite reverse',
            }} />
          <div
            style={{ position: 'absolute' as const, inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <DrpxLogoIcon size={0.5} />
          </div>
        </div>
        <div className="splash-logo" style={{ margin: '0 auto' }}>
          <DrpxLogo size={1.8} showCourier={true} dark={darkMode} />
        </div>
        <div
          style={{
            color: darkMode ? 'rgba(255,255,255,.35)' : 'rgba(12,26,14,.35)',
            fontSize: 12,
            letterSpacing: 2,
            textTransform: 'uppercase' as const,
            marginTop: 12,
          }}>
          {t('hcPlattformLaden')}
        </div>
      </div>
    </div>
  );
}
